 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"bind-sa-index0":"bind-sa-index0","bind-sa-success0":"bind-sa-success0","card0":"card0","chatRoom0~chatRoom1~groupPush0~groupPush1~reservation1~reservation2":"chatRoom0~chatRoom1~groupPush0~groupPush1~reservation1~reservation2","chatRoom0~chatRoom1~groupPush0~groupPush1":"chatRoom0~chatRoom1~groupPush0~groupPush1","groupPush0":"groupPush0","groupPush1":"groupPush1","reservation1":"reservation1","reservation2":"reservation2","chatRoom0~chatRoom1~label-create0~label-create1~label-edit0~label-edit1~my-customer-reservation-edit~17edb6c6":"chatRoom0~chatRoom1~label-create0~label-create1~label-edit0~label-edit1~my-customer-reservation-edit~17edb6c6","chatRoom0~chatRoom1":"chatRoom0~chatRoom1","chatRoom0":"chatRoom0","chatRoom1":"chatRoom1","label-create0~label-create1~label-edit0~label-edit1":"label-create0~label-create1~label-edit0~label-edit1","label-create0":"label-create0","label-create1":"label-create1","label-edit0":"label-edit0","label-edit1":"label-edit1","my-customer-reservation-edit0":"my-customer-reservation-edit0","my-customer-reservation-edit1":"my-customer-reservation-edit1","reservation-edit0":"reservation-edit0","reservation-edit1":"reservation-edit1","reservation-edit2":"reservation-edit2","sign-up0":"sign-up0","sign-up1":"sign-up1","errors":"errors","event-activity-create0":"event-activity-create0","event-activity-create1":"event-activity-create1","event-activity-create2":"event-activity-create2","event-activity-index0":"event-activity-index0","event-activity-index1":"event-activity-index1","event-activity-index2":"event-activity-index2","event-activity-index3":"event-activity-index3","event-activity-success0":"event-activity-success0","label0":"label0","label1":"label1","login":"login","my-customer-index0~my-customer-index1":"my-customer-index0~my-customer-index1","my-customer-index0":"my-customer-index0","my-customer-index1":"my-customer-index1","reservation0":"reservation0","sign-up-fail0":"sign-up-fail0","sign-up-fail1":"sign-up-fail1","sign-up-success0":"sign-up-success0","sign-up-success1":"sign-up-success1","stores-manager-edit-sa0":"stores-manager-edit-sa0","stores-manager0":"stores-manager0"}[chunkId]||chunkId) + "." + {"bind-sa-index0":"c7f2a1c0","bind-sa-success0":"9e83a3a3","card0":"7e492273","chatRoom0~chatRoom1~groupPush0~groupPush1~reservation1~reservation2":"cfb7326e","chatRoom0~chatRoom1~groupPush0~groupPush1":"2400c26b","groupPush0":"6d9edd4f","groupPush1":"f77f18aa","reservation1":"ed51f862","reservation2":"f681403d","chatRoom0~chatRoom1~label-create0~label-create1~label-edit0~label-edit1~my-customer-reservation-edit~17edb6c6":"78ca31ed","chatRoom0~chatRoom1":"71bb9d77","chatRoom0":"bfe7f7a5","chatRoom1":"c7fc6ed4","label-create0~label-create1~label-edit0~label-edit1":"618a0eeb","label-create0":"dc514222","label-create1":"d450a6f8","label-edit0":"e7ec5264","label-edit1":"ce009607","my-customer-reservation-edit0":"7b03632f","my-customer-reservation-edit1":"3ad7028f","reservation-edit0":"c95bb9f7","reservation-edit1":"8bd5b1f8","reservation-edit2":"7144750a","sign-up0":"bdeea9a6","sign-up1":"9c9a94cb","chunk-bca4ef92":"235e0229","errors":"509cd24b","event-activity-create0":"b313edfc","event-activity-create1":"094613b3","event-activity-create2":"17250bf0","event-activity-index0":"0843b0ed","event-activity-index1":"9d730467","event-activity-index2":"10d3300f","event-activity-index3":"f454e076","event-activity-success0":"2febd265","label0":"8db83224","label1":"f09e161a","login":"46e9cb99","my-customer-index0~my-customer-index1":"bdb6cae4","my-customer-index0":"fe674ae3","my-customer-index1":"c708ea2b","reservation0":"c7355fc7","sign-up-fail0":"3be6291e","sign-up-fail1":"88700aac","sign-up-success0":"3bd2b166","sign-up-success1":"c39b90c3","stores-manager-edit-sa0":"e8570217","stores-manager0":"5bf175e5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"bind-sa-success0":1,"card0":1,"chatRoom0~chatRoom1~groupPush0~groupPush1~reservation1~reservation2":1,"chatRoom0~chatRoom1~groupPush0~groupPush1":1,"groupPush0":1,"groupPush1":1,"reservation1":1,"reservation2":1,"chatRoom0~chatRoom1":1,"chatRoom0":1,"chatRoom1":1,"label-create0~label-create1~label-edit0~label-edit1":1,"sign-up0":1,"sign-up1":1,"chunk-bca4ef92":1,"errors":1,"event-activity-create0":1,"event-activity-create1":1,"event-activity-create2":1,"event-activity-index0":1,"event-activity-index1":1,"event-activity-index2":1,"event-activity-index3":1,"event-activity-success0":1,"label1":1,"my-customer-index0~my-customer-index1":1,"sign-up-fail0":1,"sign-up-fail1":1,"sign-up-success0":1,"sign-up-success1":1,"stores-manager-edit-sa0":1,"stores-manager0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"bind-sa-index0":"bind-sa-index0","bind-sa-success0":"bind-sa-success0","card0":"card0","chatRoom0~chatRoom1~groupPush0~groupPush1~reservation1~reservation2":"chatRoom0~chatRoom1~groupPush0~groupPush1~reservation1~reservation2","chatRoom0~chatRoom1~groupPush0~groupPush1":"chatRoom0~chatRoom1~groupPush0~groupPush1","groupPush0":"groupPush0","groupPush1":"groupPush1","reservation1":"reservation1","reservation2":"reservation2","chatRoom0~chatRoom1~label-create0~label-create1~label-edit0~label-edit1~my-customer-reservation-edit~17edb6c6":"chatRoom0~chatRoom1~label-create0~label-create1~label-edit0~label-edit1~my-customer-reservation-edit~17edb6c6","chatRoom0~chatRoom1":"chatRoom0~chatRoom1","chatRoom0":"chatRoom0","chatRoom1":"chatRoom1","label-create0~label-create1~label-edit0~label-edit1":"label-create0~label-create1~label-edit0~label-edit1","label-create0":"label-create0","label-create1":"label-create1","label-edit0":"label-edit0","label-edit1":"label-edit1","my-customer-reservation-edit0":"my-customer-reservation-edit0","my-customer-reservation-edit1":"my-customer-reservation-edit1","reservation-edit0":"reservation-edit0","reservation-edit1":"reservation-edit1","reservation-edit2":"reservation-edit2","sign-up0":"sign-up0","sign-up1":"sign-up1","errors":"errors","event-activity-create0":"event-activity-create0","event-activity-create1":"event-activity-create1","event-activity-create2":"event-activity-create2","event-activity-index0":"event-activity-index0","event-activity-index1":"event-activity-index1","event-activity-index2":"event-activity-index2","event-activity-index3":"event-activity-index3","event-activity-success0":"event-activity-success0","label0":"label0","label1":"label1","login":"login","my-customer-index0~my-customer-index1":"my-customer-index0~my-customer-index1","my-customer-index0":"my-customer-index0","my-customer-index1":"my-customer-index1","reservation0":"reservation0","sign-up-fail0":"sign-up-fail0","sign-up-fail1":"sign-up-fail1","sign-up-success0":"sign-up-success0","sign-up-success1":"sign-up-success1","stores-manager-edit-sa0":"stores-manager-edit-sa0","stores-manager0":"stores-manager0"}[chunkId]||chunkId) + "." + {"bind-sa-index0":"31d6cfe0","bind-sa-success0":"9bae9b8e","card0":"951f90ce","chatRoom0~chatRoom1~groupPush0~groupPush1~reservation1~reservation2":"9bae9b8e","chatRoom0~chatRoom1~groupPush0~groupPush1":"2113b051","groupPush0":"23b06e36","groupPush1":"4d8cf7f7","reservation1":"8f544e7c","reservation2":"3a7393c2","chatRoom0~chatRoom1~label-create0~label-create1~label-edit0~label-edit1~my-customer-reservation-edit~17edb6c6":"31d6cfe0","chatRoom0~chatRoom1":"b2abecf4","chatRoom0":"84cd4ea3","chatRoom1":"3700a6d3","label-create0~label-create1~label-edit0~label-edit1":"9bae9b8e","label-create0":"31d6cfe0","label-create1":"31d6cfe0","label-edit0":"31d6cfe0","label-edit1":"31d6cfe0","my-customer-reservation-edit0":"31d6cfe0","my-customer-reservation-edit1":"31d6cfe0","reservation-edit0":"31d6cfe0","reservation-edit1":"31d6cfe0","reservation-edit2":"31d6cfe0","sign-up0":"e797354f","sign-up1":"fedf16c6","chunk-bca4ef92":"730dedb7","errors":"58a5e596","event-activity-create0":"93ab1df9","event-activity-create1":"e5d45dbb","event-activity-create2":"935ff5da","event-activity-index0":"a6314011","event-activity-index1":"a3e06b19","event-activity-index2":"33a24812","event-activity-index3":"c3ebfee1","event-activity-success0":"4ebe3422","label0":"31d6cfe0","label1":"18753128","login":"31d6cfe0","my-customer-index0~my-customer-index1":"9bae9b8e","my-customer-index0":"31d6cfe0","my-customer-index1":"31d6cfe0","reservation0":"31d6cfe0","sign-up-fail0":"9ed97fa8","sign-up-fail1":"3d982482","sign-up-success0":"0c17bf4f","sign-up-success1":"554febba","stores-manager-edit-sa0":"9bae9b8e","stores-manager0":"79c12bbe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/one-to-one/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
